export default __webpack_public_path__ + "assets/images/d03e787223f419ec81e25e8bc8f8caf4.png";